<template>
  <v-dialog :value="value" scrollable max-width="900" @input="!$event && cerrar()">
    <v-card class="ut-buscar-turno">
      <v-card-title>{{ titulo }}<v-spacer /><v-btn icon title="Cerrar" aria-label="Cerrar buscador de turnos" @click="cerrar"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
      <v-card-text>
        <form class="ut-turno-filtros" @submit.prevent="buscar(1)">
          <v-text-field v-model="fecha" type="date" label="Fecha" outlined dense hide-details @input="invalidar" />
          <v-btn-toggle v-model="sentido" mandatory dense @change="invalidar"><v-btn :value="true">Ida</v-btn><v-btn :value="false">Vuelta</v-btn></v-btn-toggle>
          <v-btn type="submit" color="primary" small :loading="cargando"><v-icon left small>mdi-magnify</v-icon>Buscar</v-btn>
        </form>
        <v-alert v-if="error" type="error" outlined dense role="alert">{{ error }}</v-alert>
        <div class="ut-turno-lista"><table>
          <thead><tr><th v-if="correccion" v-for="col in columnas" :key="col.campo" :aria-sort="orden === col.campo ? (direccion === 'desc' ? 'descending' : 'ascending') : null"><button type="button" :disabled="cargando" :title="'Ordenar por ' + col.titulo" @click="ordenar(col.campo)">{{ col.titulo }}<v-icon small>{{ orden === col.campo ? (direccion === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up') : 'mdi-unfold-more-horizontal' }}</v-icon></button></th><template v-if="!correccion"><th>Viaje</th><th>Hora</th><th>Ficha</th><th>Chofer</th><th>Estado</th></template><th></th></tr></thead>
          <tbody><tr v-for="fila in filas" :key="fila.id" @dblclick="elegir(fila)">
            <template v-if="correccion"><td v-for="col in columnas" :key="col.campo">{{ col.campo === 'fecha_presentacion' ? fechaDetalle(fila.fecha_presentacion || fila.fecha, true) : fila[col.campo] }}</td></template>
            <template v-else><td>{{ numeroViaje(fila) }}</td><td>{{ fila.hora }}</td><td>{{ fila.ficha }}</td><td>{{ fila.conductor }}</td><td>{{ fila.turno_cerrado ? 'Cerrado' : 'Abierto' }}</td></template>
            <td><v-btn icon :disabled="cargando" title="Seleccionar turno" :aria-label="'Seleccionar ' + numeroViaje(fila)" @click="elegir(fila)"><v-icon>mdi-check</v-icon></v-btn></td>
          </tr><tr v-if="!filas.length"><td :colspan="correccion ? columnas.length + 1 : 6">{{ cargando ? 'Consultando...' : 'Sin turnos para esta fecha y sentido.' }}</td></tr></tbody>
        </table></div>
      </v-card-text>
      <v-card-actions><span>{{ total }} turnos</span><v-spacer />
        <v-btn icon :disabled="cargando || pagina <= 1" title="Pagina anterior" @click="buscar(pagina - 1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <span>{{ pagina }} / {{ Math.max(1, Math.ceil(total / 50)) }}</span>
        <v-btn icon :disabled="cargando || pagina * 50 >= total" title="Pagina siguiente" @click="buscar(pagina + 1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { fechaValida, hoy, textoError, esVerdadero } from './catalogo';
import { fechaDetalle } from './detalleVenta';
export function numeroViaje(fila) {
  const fecha = fechaDetalle(fila.fecha, true);
  return fila.id && fecha ? `${esVerdadero(fila.es_sentido_ida) ? 'I' : 'V'}-${fecha.replace(/\//g, '')}-${fila.numero_turno}` : '';
}
export default {
  name: 'BuscarTurnoUtilitario',
  props: { value: Boolean, titulo: String, fechaInicial: String, sentidoInicial: { default: true }, correccion: Boolean, consultar: { type: Function, required: true } },
  data: () => ({ fecha: '', sentido: true, filas: [], total: 0, pagina: 1, cargando: false, error: '', peticion: 0, orden: 'numero_turno', direccion: 'asc',
    columnas: [['fecha_presentacion', 'Fecha'], ['hora', 'Hora'], ['numero_turno', 'Turno'], ['ficha', 'Ficha'], ['conductor', 'Chofer'], ['id', 'ID turno'], ['vehiculo', 'ID ficha'], ['idchofer', 'ID chofer']].map(([campo, titulo]) => ({ campo, titulo })) }),
  watch: {
    value(valor) {
      this.invalidar();
      if (valor) { this.fecha = fechaValida(this.fechaInicial) ? this.fechaInicial : hoy(); this.sentido = this.sentidoInicial !== false; this.orden = 'numero_turno'; this.direccion = 'asc'; this.buscar(1); }
    },
  },
  beforeDestroy() { this.peticion++; },
  methods: {
    numeroViaje, fechaDetalle,
    ordenar(campo) {
      if (!this.correccion || this.cargando || !this.columnas.some(c => c.campo === campo)) return;
      this.direccion = this.orden === campo && this.direccion === 'asc' ? 'desc' : 'asc'; this.orden = campo; return this.buscar(1);
    },
    invalidar() { this.peticion++; this.filas = []; this.total = 0; this.pagina = 1; this.error = ''; this.cargando = false; },
    cerrar() { this.invalidar(); this.$emit('input', false); },
    elegir(fila) { if (this.value && !this.cargando && this.filas.includes(fila)) { this.$emit('seleccionar', { ...fila, numero_viaje: numeroViaje(fila) }); this.cerrar(); } },
    async buscar(pagina = 1) {
      if (!this.value || this.cargando) return;
      if (!fechaValida(this.fecha)) { this.error = 'Indique una fecha valida.'; return; }
      const token = ++this.peticion; this.cargando = true; this.error = ''; this.filas = [];
      try {
        const data = await this.consultar({ fecha: this.fecha, es_sentido_ida: this.sentido, pagina, tamano: 50, ...(this.correccion ? { orden: this.orden, direccion: this.direccion } : {}) });
        if (token !== this.peticion || !this.value) return;
        if (!data || !Array.isArray(data.filas) || !Number.isFinite(Number(data.total))) throw new Error('No se pudo cargar el listado de turnos.');
        this.filas = data.filas; this.total = Number(data.total); this.pagina = pagina;
      } catch (error) { if (token === this.peticion) { this.error = textoError(error); this.total = 0; } }
      finally { if (token === this.peticion) this.cargando = false; }
    },
  },
};
</script>

<style scoped>
.ut-turno-filtros { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 8px 0 16px; }
.ut-turno-filtros > .v-input { max-width: 210px; min-width: 150px; }
.ut-turno-lista { overflow: auto; min-height: 220px; max-height: 55vh; }
.ut-turno-lista table { border-collapse: collapse; width: 100%; font-size: 13px; }
.ut-turno-lista th { background: #edf2f5; text-align: left; position: sticky; top: 0; }
.ut-turno-lista th, .ut-turno-lista td { padding: 8px; border-bottom: 1px solid #d8e0e6; }
.ut-turno-lista th button { display: flex; align-items: center; white-space: nowrap; font: inherit; color: inherit; }
.ut-turno-lista td:first-child { white-space: nowrap; }
.ut-turno-lista tr:hover { background: #e8f2f9; }
</style>
